import { get } from '../utils/request';

export const getTextImage = function (queries, config) {
  const api = 'TextImage';
  const requestUrl = `/api/v1/${api}${queries}`;
  return get(requestUrl, null, config);
};
